import { createNullableContext, memoryBinding } from "@pltk/components";
import { createContext } from "react";
import { EditableState } from "./widgets/base";
export const EditableStateContext = createContext(memoryBinding(EditableState.Edit));
export const PreviewModeContext = createContext(false);
export const PanelSizeContext = createNullableContext("Panel not initialized");
